// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__cPIk6","footer":"styles_footer__rs8cN"};